/**
 * Leitura crua do `BF_SELLER_DATASETS`.
 *
 * Cada registro é um arquivo inteiro, então a única leitura que existe é `getAll` da store: quem
 * indexa o conteúdo em memória é o `bfSellerCache`, quem reconstrói o formato legado é o
 * `bfSellerHydrate` e quem pagina é o `bfSellerProducts` / `bfSellerClients`.
 *
 * Falha de leitura não derruba a tela: devolve vazio e registra, que é como o app se comporta
 * quando o banco ainda não foi populado.
 */

import { openBfSellerDb } from './bfSellerDb';
import type { BfSellerStore } from './bfSellerSchema';

const emptyOnError = <T>(fallback: T, store: string, error: unknown): T => {
  console.info(`[BF_SELLER_DATASETS] falha ao ler ${store}:`, error);
  return fallback;
};

export const readValues = async <T = any>(store: BfSellerStore, range?: IDBKeyRange): Promise<T[]> => {
  try {
    const db = await openBfSellerDb();
    return (await db.getAll(store, range)) as T[];
  } catch (error) {
    return emptyOnError([] as T[], store, error);
  }
};
